export default __webpack_public_path__ + "static/media/game-rent.b0b53711.webp";